<template>
  <b-row class="flex-column mx-3 text-blue-500">
    <b-col v-if="loader" class="mb-2 d-block">
      <b-skeleton height="51px" animation="fade" class="mb-0"></b-skeleton>
    </b-col>
    <b-col v-else class="mb-2 d-block">
      <div class="text-md d-flex align-items-start">
        <b-icon-circle-fill
          v-if="isChildPage"
          variant="salmon-500"
          class="mr-2 mt-2"
          font-scale="0.6"
        />
        <p class="mb-0">{{ $t('childrenList.card.futureSelf') }}</p>
        <Tooltip v-if="!isChildPage" class="text-blue"></Tooltip>
      </div>
      <p
        :class="['overflow-hidden', { 'mb-4': !isChildPage }, { 'mb-0 text-lg ml-3': isChildPage }]"
      >
        {{ getShortText(futureSelf, endIndex) }}
      </p>
    </b-col>
    <b-col v-if="loader" class="mb-2">
      <b-skeleton height="51px" animation="fade" class="mb-0"></b-skeleton>
    </b-col>
    <b-col v-else class="mb-2">
      <div class="text-md d-flex align-items-start">
        <b-icon-circle-fill
          v-if="isChildPage"
          variant="salmon-500"
          class="mr-2 mt-2"
          font-scale="0.6"
        />
        <p class="mb-0">{{ threeWordsLabel }}</p>
        <Tooltip v-if="!isChildPage" class="text-blue"></Tooltip>
      </div>
      <p :class="['mb-0 overflow-hidden', { 'text-lg ml-3': isChildPage }]">
        {{ getShortText(threeWordsDescription, endIndex) }}
      </p>
    </b-col>
  </b-row>
</template>

<script>
import Tooltip from '@/components/widgets/Tooltip.vue'

export default {
  name: 'ChildDescription',
  components: { Tooltip },
  props: {
    futureSelf: {
      required: true,
      type: String
    },
    threeWordsDescription: {
      required: true,
      type: String
    },
    loader: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      endIndex: 80
    }
  },
  computed: {
    threeWordsLabel() {
      return this.$route.name === 'Home'
        ? this.$t('childrenList.card.threeWordsDescription')
        : this.$t('childPage.threeWordsDescription')
    },
    isChildPage() {
      return this.$route.name === 'ChildPage' || this.$route.name === 'ChildPageRetention'
    }
  },
  methods: {
    getShortText(text, endIndex) {
      if (text.length <= endIndex || this.isChildPage) {
        return text
      }
      const maxText = text.substring(0, endIndex)
      const spaceComma = maxText.lastIndexOf(', ') > -1 ? maxText.lastIndexOf(', ') : endIndex
      const comma = maxText.lastIndexOf(',') > -1 ? maxText.lastIndexOf(',') : endIndex
      return `${text.substring(0, Math.max(spaceComma, comma))}...`
    }
  }
}
</script>
